export const MESSAGE = {
  UPDATE_SUCCESS: 'Cập nhật thành công!',
  UPDATE_FAIL: 'Cập nhật thất bại!',
  DELETE_SUCCESS: 'Xoá thành công!',
  DELETE_FAIL: 'Xoá thất bại!',
  CREATE_SUCCESS: 'Tạo thành công!',
  CREATE_FAIL: 'Tạo thất bại!',
  LOGIN_FIELD: 'Đăng nhập thất bại!',
  LOGIN_SUCCESS: 'Đăng nhập thành công!',
  REGISTER_FAILED: 'Tạo tài khoản thất bại!',
  ACCOUNT_NOT_FOUND: 'Vui lòng đăng nhập!',
  LOGOUT_FAILED: 'Đăng xuất thất bại!',
  LOGOUT_SUCCESS: 'Đăng xuất thành công!',
  CREATE_ADMIN_SUCCESS: 'Tạo tài khoản admin thành công!',
  CREATE_ADMIN_FAIL: 'Tạo tài khoản admin thất bại!',
  UPDATE_ADMIN_SUCCESS: 'Cập nhật tài khoản admin thành công!',
  UPDATE_ADMIN_FAIL: 'Cập nhật tài khoản admin thất bại!',
  DELETE_ADMIN_SUCCESS: 'Xoá tài khoản admin thành công!',
  DELETE_ADMIN_FAIL: 'Xoá tài khoản admin thất bại!',
  CREATE_ROLE_SUCCESS: 'Tạo vai trò thành công!',
  CREATE_ROLE_FAIL: 'Tạo vai trò thất bại!',
  DELETE_ROLE_SUCCESS: 'Xoá vai trò thành công!',
  DELETE_ROLE_FAIL: 'Xoá vai trò thất bại!',
  UPDATE_ROLE_SUCCESS: 'Cập nhật vai trò thành công!',
  UPDATE_ROLE_FAIL: 'Cập nhật vai trò thất bại!',
  DELETE_BANNER_SUCCESS: 'Xóa banner thành công!',
  DELETE_BANNER_FAIL: 'Xóa banner thất bại!',
  CREATE_BANNER_SUCCESS: 'Tạo banner thành công!',
  CREATE_BANNER_FAIL: 'Tạo banner thất bại!',
  UPDATE_BANNER_SUCCESS: 'Cập nhật banner thành công!',
  UPDATE_BANNER_FAIL: 'Cập nhật banner thất bại!',
  UPDATE_BANNER_TIME_SUCCESS: 'Cập nhật thời gian chuyển banner thành công',
  UPDATE_BANNER_TIME_FAIL: 'Cập nhật thời gian chuyển banner thất bại',
  SORT_BANNER_TIME_SUCCESS: 'Sắp xếp thứ tự hiển thị banner thành công',
  SORT_BANNER_TIME_FAIL: 'Sắp xếp thứ tự hiển thị banner thất bại',
  CREATE_HOME_PAGE_US_SUCCESS: 'Tạo trang về chúng tôi thành công!',
  CREATE_HOME_PAGE_US_FAIL: 'Tạo trang về chúng tôi thất bại!',
  DELETE_PHYSICAL_ACTIVITY_SUCCESS: 'Xóa mức độ hoạt động thể lực thành công!',
  DELETE_PHYSICAL_ACTIVITY_FAIL: 'Xóa mức độ hoạt động thể lực thất bại!',
  CREATE_PHYSICAL_ACTIVITY_SUCCESS: 'Tạo mức độ hoạt động thể lực thành công!',
  CREATE_PHYSICAL_ACTIVITY_FAIL: 'Tạo mức độ hoạt động thể lực thất bại!',
  UPDATE_PHYSICAL_ACTIVITY_SUCCESS: 'Cập nhật mức độ hoạt động thể lực thành công!',
  UPDATE_PHYSICAL_ACTIVITY_FAIL: 'Cập nhật mức độ hoạt động thể lực thất bại!',
  DELETE_PHYSICAL_ACTIVITY_BY_INTENSITY_SUCCESS: 'Xóa hoạt động thể lực theo cường độ vận động thành công!',
  DELETE_PHYSICAL_ACTIVITY_INTENSITY_FAIL: 'Xóa hoạt động thể lực theo cường độ vận động thất bại!',
  CREATE_PHYSICAL_ACTIVITY_INTENSITY_SUCCESS: 'Tạo hoạt động thể lực theo cường độ vận động thành công!',
  CREATE_PHYSICAL_ACTIVITY_INTENSITY_FAIL: 'Tạo hoạt động thể lực theo cường độ vận động thất bại!',
  UPDATE_PHYSICAL_ACTIVITY_INTENSITY_SUCCESS: 'Cập nhật hoạt động thể lực theo cường độ vận động thành công!',
  UPDATE_PHYSICAL_ACTIVITY_INTENSITY_FAIL: 'Cập nhật hoạt động thể lực theo cường độ vận động thất bại!',
  DELETE_PRODUCT_SUCCESS: 'Xóa thành công!',
  DELETE_PRODUCT_FAIL: 'Xóa sản phẩm thất bại!',
  CREATE_PRODUCT_SUCCESS: 'Thêm mới thành công!',
  CREATE_PRODUCT_FAIL: 'Tạo sản phẩm thất bại!',
  UPDATE_PRODUCT_SUCCESS: 'Lưu thay đổi thành công!',
  UPDATE_PRODUCT_FAIL: 'Cập nhật sản phẩm thất bại!',
  DELETE_FOOD_SUCCESS: 'Xóa thực phẩm thành công!',
  DELETE_FOOD_FAIL: 'Xóa thực phẩm thất bại!',
  CREATE_FOOD_SUCCESS: 'Tạo thực phẩm thành công!',
  CREATE_FOOD_FAIL: 'Tạo thực phẩm thất bại!',
  UPDATE_FOOD_SUCCESS: 'Cập nhật thực phẩm thành công!',
  UPDATE_FOOD_FAIL: 'Cập nhật thực phẩm thất bại!',
  UPDATE_GROUP_FOOD_SUCCESS: 'Cập nhật nhóm thực phẩm thành công!',
  UPDATE_GROUP_FOOD_FAIL: 'Cập nhật nhóm thực phẩm thất bại!',
  IMPORT_FOOD_SUCCESS: 'Tải lên thành công!',
  IMPORT_FOOD_FAIL: 'Tải lên thất bại!',
  DELETE_QUANTITATION_FOOD_SUCCESS: 'Xóa định lượng thực phẩm thành công!',
  DELETE_QUANTITATION_FOOD_FAIL: 'Xóa định lượng thực phẩm thất bại!',
  CREATE_QUANTITATION_FOOD_SUCCESS: 'Tạo định lượng thực phẩm thành công!',
  CREATE_QUANTITATION_FOOD_FAIL: 'Tạo định lượng thực phẩm thất bại!',
  UPDATE_QUANTITATION_FOOD_SUCCESS: 'Cập nhật định lượng thực phẩm thành công!',
  UPDATE_QUANTITATION_FOOD_FAIL: 'Cập nhật định lượng thực phẩm thất bại!',
  IMPORT_PRODUCT_SUCCESS: 'Tải lên thành công!',
  IMPORT_PRODUCT_FAIL: 'File tải lên không đúng định dạng!',
  FETCH_FAIL: 'Không thể lấy dữ liệu!',
  FETCH_SUCCESS: 'Lấy dữ liệu thành công!',
  DELETE_DISH_SUCCESS: 'Xóa thành công!',
  DELETE_DISH_FAIL: 'Xóa món ăn thất bại!',
  CREATE_DISH_SUCCESS: 'Tạo món ăn thành công!',
  CREATE_DISH_FAIL: 'Tạo món ăn thất bại!',
  UPDATE_DISH_SUCCESS: 'Cập nhật thành công!',
  UPDATE_DISH_FAIL: 'Cập nhật món ăn thất bại!',
  IMPORT_DISH_SUCCESS: 'Tải lên thành công!',
  IMPORT_DISH_FAIL: 'File tải lên không đúng định dạng!',
  CREATE_COMBO_FOOD_SUCCESS: 'Tạo combo thực phẩm thành công!',
  CREATE_COMBO_FOOD_FAIL: 'Tạo combo thực phẩm thất bại!',
  UPDATE_COMBO_FOOD_SUCCESS: 'Cập nhật combo thực phẩm thành công!',
  UPDATE_COMBO_FOOD_FAIL: 'Cập nhật combo thực phẩm thất bại!',
  DELETE_COMBO_FOOD_SUCCESS: 'Xóa thành công thực đơn xây dựng chi tiết cho đối tượng',
  DELETE_COMBO_FOOD_FAIL: 'Xóa combo thực phẩm thất bại!',
  CREATE_MEAL_SUCCESS: 'Tạo thực đơn thành công!',
  CREATE_MEAL_FAIL: 'Tạo thực đơn thất bại!',
  UPDATE_MEAL_SUCCESS: 'Lưu thực đơn thành công!',
  UPDATE_MEAL_FAIL: 'Cập nhật thực đơn thất bại!',
  DELETE_MEAL_SUCCESS: 'Xóa thực đơn thành công!',
  DELETE_MEAL_FAIL: 'Xóa thực đơn thất bại!',
  IMPORT_COMBO_FOOD_SUCCESS: 'Nhập dữ liệu thực đơn chi tiết thành công',
  IMPORT_COMBO_FOOD_FAIL: 'Tải lên thất bại!',
  GET_LIST_ADVICE_SUCCESS: 'Lấy danh sách lời khuyên thành công!',
  GET_LIST_ADVICE_FAIL: 'Lấy danh sách lời khuyên thất bại!',
  UPDATE_ADVICE_SUCCESS: 'Cập nhật lời khuyên thành công!',
  UPDATE_ADVICE_FAIL: 'Cập nhật lời khuyên thất bại!',
  CREATE_NUTRITION_STANDARD_SUCCESS: 'Thêm mới thành công!',
  UPDATE_NUTRITION_STANDARD_SUCCESS: 'Cập nhật thành công!',
  DELETE_NUTRITION_STANDARD_SUCCESS: 'Xóa thành công!',
  REQUIRED_NUTRITION_STANDARD: 'Vui lòng nhập giá trị!',
  CREATE_NUTRITION_STANDARD_FAIL: 'Thêm mới thất bại!',
  UPDATE_NUTRITION_STANDARD_FAIL: 'Cập nhật thất bại!',
  DELETE_NUTRITION_STANDARD_FAIL: 'Xóa thất bại!',
  IMPORT_NUTRITION_TEMPLATE_ERROR: 'Sai template nhập liệu, vui lòng kiểm tra file và tải lên lại!',
  IMPORT_NUTRITION_MISMATCH_ERROR: 'Lỗi tình trạng sức khỏe hoặc độ tuổi không trùng khớp với file tải lên!',
  IMPORT_NUTRITION_STANDARD_SUCCESS: 'Tải lên thành công!',
  UPLOAD_ALL_FILE_KEY_CONFIG_FAIL: "Tải lên thất bại!",
  UPLOAD_ALL_FILE_KEY_CONFIG_SUCCESS: "Tải lên thành công!",
  UPDATE_OPEN_API_KEY_SUCCESS: "Cập nhật API Key thành công!",
  UPDATE_OPEN_API_KEY_FAIL: "Cập nhật API Key thất bại!",
  CREATE_NOTIFICATION_SUCCESS: 'Tạo thông báo thành công!',
  CREATE_NOTIFICATION_FAIL: 'Tạo thông báo thất bại!',
  UPDATE_NOTIFICATION_SUCCESS: 'Cập nhật thông báo thành công!',
  UPDATE_NOTIFICATION_FAIL: 'Cập nhật thông báo thất bại!',
  DELETE_NOTIFICATION_SUCCESS: 'Xoá thông báo thành công!',
  DELETE_NOTIFICATION_FAIL: 'Xoá thông báo thất bại!',
  CREATE_EMAIL_NOTIFICATION_SUCCESS: 'Tạo thông báo email thành công!',
  CREATE_EMAIL_NOTIFICATION_FAIL: 'Tạo thông báo email thất bại!',
  UPDATE_EMAIL_NOTIFICATION_SUCCESS: 'Cập nhật thông báo email thành công!',
  UPDATE_EMAIL_NOTIFICATION_FAIL: 'Cập nhật thông báo email thất bại!',
  DELETE_EMAIL_NOTIFICATION_SUCCESS: 'Xoá thông báo email thành công!',
  DELETE_EMAIL_NOTIFICATION_FAIL: 'Xoá thông báo email thất bại!',
  GET_EMAIL_NOTIFICATION_DETAIL_FAIL: 'Lấy chi tiết thông báo email thất bại!',
  GET_NOTIFICATION_DETAIL_FAIL: 'Lấy chi tiết thông báo thất bại!',
  GET_LIST_NOTIFICATION_FAIL: 'Lấy danh sách thất bại!',
  CREATE_BANNER_HEADER_SUCCESS: 'Tạo banner header thành công!',
  CREATE_BANNER_HEADER_FAIL: 'Tạo banner header thất bại!',
  UPDATE_BANNER_HEADER_SUCCESS: 'Cập nhật banner header thành công!',
  UPDATE_BANNER_HEADER_FAIL: 'Cập nhật banner header thất bại!',
  DELETE_BANNER_HEADER_SUCCESS: 'Xóa banner header thành công!',
  DELETE_BANNER_HEADER_FAIL: 'Xóa banner header thất bại!'
};

export const DESCRIPTION = {
  ADMIN_USER_EXIST: 'Tài khoản đã tồn tại.',
  ROLE_EXIST: 'Vai trò đã tồn tại.'
};

export const REQUEST_VALIDATION = {
  ERROR_ID: 'ID món ăn đã tồn tại với độ tuổi này!'
}